<hive-button
    emphasis="tertiary"
    [icon]="faAngleLeft"
    [disabled]="!canMoveLeft()"
    (click)="setVariation.next(message.selectedVariationIndex - 1)"
/>
<span class="count-label"> {{ message.selectedVariationIndex + 1 }} / {{ message.variations.length }} </span>
<hive-button
    emphasis="tertiary"
    [icon]="faAngleRight"
    [disabled]="!canMoveRight()"
    (click)="setVariation.next(message.selectedVariationIndex + 1)"
/>
